<template>
  <div class="registerBox">
    <div class="register">
      <!-- 顶部导航栏 -->
      <div class="header">
        <div class="header-content">
          <div class="left-box">
            <webLogo></webLogo>
            <div class="title">注册</div>
          </div>
          <div class="btn" @click="gologin">去登录</div>
        </div>
      </div>
      <el-card class="from-card">
        <el-form class="rform" ref="registerForm" :model="form" :rules="rules" label-position="right" label-width="140px">
          <div class="line" style="margin: 30px 0">
            <span class="title">基本信息</span>
            <!-- 联系客服提示 -->
            <div class="contact-service">
              如有疑问请联系客服<span>027-96755</span>
            </div>
          </div>
            <!-- 驳回信息提示 -->
          <div class="reject-info" v-if="showReject">
            <i class="el-icon-warning"></i>
            <span>注册未通过原因：{{ rejectReason }}</span>
          </div>
          <!-- 邀请码 -->
          <el-form-item label="邀请码" prop="invitationCode">
            <el-input type="text" v-model="form.invitationCode" placeholder="请输入8位邀请码" maxlength="8" @blur="checkInvitationCode"></el-input>
          </el-form-item>

          <!-- 联系人姓名 -->
          <el-form-item label="联系人姓名" prop="toucherName">
            <el-input type="text" v-model="form.toucherName" placeholder="请输入联系人姓名" maxlength="20"></el-input>
          </el-form-item>
          <!-- 联系人手机号 -->
          <el-form-item label="联系人手机号" prop="toucherMobile">
            <el-input type="text" v-model="form.toucherMobile" placeholder="请输入联系人手机号" maxlength="11" @blur="onMobileBlur"></el-input>
          </el-form-item>
          <!-- 短信验证码 -->
          <el-form-item label="短信验证码" prop="phoneCode">
            <el-input type="text" class="code" v-model="form.phoneCode" placeholder="请输入6位数字验证码" maxlength="6">
              <el-button slot="append" @click="getcode" v-bind:class="getcodeflage ? 'codebtn' : 'huibtn'" :disabled="!getcodeflage">{{
                getcodetext == '获取验证码' ? '获取验证码' : getcodetext + '秒后重新获取'
              }}</el-button>
            </el-input>
          </el-form-item>
          <!-- 登录账号 -->
          <el-form-item label="登录账号" prop="account">
            <el-input type="text" v-model="form.account" placeholder="请输入登录账号" @blur="checkAccountExist"></el-input>
          </el-form-item>
          <!-- 设置登录密码 -->
          <el-form-item label="设置登录密码" prop="password">
            <el-input :type="showPass ? 'text' : 'password'" placeholder="请输入密码" v-model="form.password"></el-input>
            <!-- 密码可见切换图标 -->
            <img class="showPass" src="@static/images/login/icon-by.png" @click="showPass = !showPass" v-if="!showPass" />
            <img class="showPass" src="@static/images/login/icon-zhengyan.png" v-if="showPass" @click="showPass = !showPass" />
          </el-form-item>
          <!-- 再次确认密码 -->
          <el-form-item label="再次确认密码" prop="confirmPassword">
            <el-input :type="showConfirmPass ? 'text' : 'password'" placeholder="请再次输入密码" v-model="form.confirmPassword"></el-input>
            <!-- 确认密码可见切换图标 -->
            <img class="showPass" src="@static/images/login/icon-by.png" @click="showConfirmPass = !showConfirmPass" v-if="!showConfirmPass" />
            <img class="showPass" src="@static/images/login/icon-zhengyan.png" v-if="showConfirmPass" @click="showConfirmPass = !showConfirmPass" />
          </el-form-item>
          <!-- 密码提示 -->
          <div class="text3"><i class="el-icon-warning-outline"></i><span>密码8-16位长度，包括大小写字母、数字和特殊字符中至少三种类型</span></div>

          <!-- 企业信息区域 -->
          <div class="line" style="margin: 60px 0">
            <span class="title">企业信息</span>
          </div>
          <!-- 企业名称 -->
          <el-form-item label="企业名称" prop="name">
            <el-input type="text" v-model="form.name" placeholder="请输入企业工商注册全称" maxlength="100"></el-input>
          </el-form-item>
          <!-- 所属行业 -->
          <el-form-item label="所属行业" prop="mechanType">
            <el-radio-group v-model="form.mechanType">
              <el-radio label="3">中介</el-radio>
              <el-radio label="5">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 是否持牌 -->
          <el-form-item label="是否持牌" prop="isLicensed">
            <el-radio-group v-model="form.isLicensed" @change="form.licenseType = ''">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 持牌类型 -->
          <el-form-item v-if="form.isLicensed == 1" label="持牌类型" prop="licenseType">
            <el-radio-group v-model="form.licenseType">
              <el-radio label="1">全国持牌</el-radio>
              <el-radio label="2">区域持牌</el-radio>
              <el-radio label="0">引流合作</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 企业注册地（省/市） -->
          <el-form-item label="企业注册地" required>
            <el-col :span="11">
              <el-form-item prop="province">
                <el-select class="selects" v-model="form.province" placeholder="省份" @change="provinceChange">
                  <el-option v-for="(item, i) in provinces" :value="item.name" :key="i"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <span class="konke">-</span>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="city">
                <el-select class="selects" v-model="form.city" placeholder="城市">
                  <el-option v-for="(item, i) in citys" :value="item.name" :key="i"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <!-- 详细地址 -->
          <el-form-item label="详细地址" prop="address">
            <el-input type="text" v-model="form.address" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <!-- 统一社会信用代码 -->
          <el-form-item label="统一社会信用代码" prop="businessLicenseNo">
            <el-input type="text" v-model="form.businessLicenseNo" placeholder="请输入18位统一社会信用代码" maxlength="18"></el-input>
          </el-form-item>
          <!-- 营业执照上传 -->
          <el-form-item label="营业执照" prop="businessLicenseImg">
            <el-upload
              class="upload-dragger"
              drag
              :action="$config.api_root + '/resmgr/upload'"
              :show-file-list="false"
              :on-success="res => uploadSuccess(res, 'businessLicenseImg')"
              :accept="'.jpg,.jpeg,.png'"
              :before-upload="beforeUpload"
            >
              <!-- 已上传图片预览 -->
              <template v-if="form.businessLicenseImg && isImageUrl(form.businessLicenseImg)">
                <img :src="form.businessLicenseImg" class="upload-preview" />
                <div class="upload-replace">点击或拖拽更换</div>
              </template>
              <!-- 已上传PDF文件预览 -->
              <template v-else-if="form.businessLicenseImg">
                <div class="upload-file-info">
                  <i class="el-icon-document"></i>
                  <span>{{ getFileName(form.businessLicenseImg) }}</span>
                </div>
                <div class="upload-replace">点击或拖拽更换</div>
              </template>
              <!-- 未上传时占位 -->
              <template v-else>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </template>
            </el-upload>
            <div class="upload-tip">支持JPEG/JPG/PNG格式，不超过10MB</div>
          </el-form-item>
          <!-- 保险中介许可证上传（行业为中介时必填） -->
          <el-form-item
            label="保险中介许可证"
            prop="intermediaryLicenseImg"
            :rules="form.mechanType == 3 ? { required: true, message: '请上传保险中介许可证', trigger: 'change' } : { required: false }"
          >
            <el-upload
              class="upload-dragger"
              drag
              :accept="'.jpg,.jpeg,.png'"
              :action="$config.api_root + '/resmgr/upload'"
              :show-file-list="false"
              :on-success="res => uploadSuccess(res, 'intermediaryLicenseImg')"
              :before-upload="beforeUpload"
            >
              <!-- 已上传图片预览 -->
              <template v-if="form.intermediaryLicenseImg && isImageUrl(form.intermediaryLicenseImg)">
                <img :src="form.intermediaryLicenseImg" class="upload-preview" />
                <div class="upload-replace">点击或拖拽更换</div>
              </template>
              <!-- 已上传PDF文件预览 -->
              <template v-else-if="form.intermediaryLicenseImg">
                <div class="upload-file-info">
                  <i class="el-icon-document"></i>
                  <span>{{ getFileName(form.intermediaryLicenseImg) }}</span>
                </div>
                <div class="upload-replace">点击或拖拽更换</div>
              </template>
              <!-- 未上传时占位 -->
              <template v-else>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </template>
            </el-upload>
            <div class="upload-tip">支持JPEG/JPG/PNG格式，不超过10MB</div>
          </el-form-item>

          <!-- 发票信息区域 -->
          <div class="line" style="margin: 60px 0">
            <span class="title">开票及收款账户信息</span>
          </div>
          <!-- 发票类型，mechanTaxLevel直接传接口：1=专票6%，2=专票3%，4=专票1%，3=普票 -->
          <el-form-item label="发票类型" prop="mechanTaxLevel">
            <el-radio-group v-model="form.mechanTaxLevel">
              <el-radio label="1">专票6%</el-radio>
              <el-radio label="2">专票3%</el-radio>
              <el-radio label="4">专票1%</el-radio>
              <el-radio label="3">普票</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 账户名 -->
          <el-form-item label="账户名" prop="bankUserName">
            <el-input type="text" v-model="form.bankUserName" placeholder="请输入账户名"></el-input>
          </el-form-item>
          <!-- 对公账号 -->
          <el-form-item label="对公账号" prop="bankAccount">
            <el-input type="text" v-model="form.bankAccount" placeholder="请输入对公账号" @blur="getBankInfo(form.bankAccount)"></el-input>
          </el-form-item>
          <!-- 开户行 -->
          <el-form-item label="开户行" prop="bankType">
            <el-input type="text" v-model="form.bankType" placeholder="请输入开户行"></el-input>
          </el-form-item>
          <!-- 开户支行 -->
          <el-form-item label="开户支行" prop="bankAddress">
            <el-input type="text" v-model="form.bankAddress" placeholder="请输入开户支行"></el-input>
          </el-form-item>
        </el-form>
        <!-- 用户协议 -->
        <div class="user-privacy">
          <el-checkbox v-model="isConfirm">我已知晓并同意</el-checkbox>
          <span class="link" @click="link('/fxyf/agreement.html')">《用户服务协议》、</span>
          <span class="link" @click="link('/fxyf/privacy-policy.html')">《隐私政策》</span>
        </div>
        <div class="info-box">
          <div class="godl">已有账号？<u @click="gologin">去登录</u></div>
        </div>
        <!-- 提交按钮 -->
        <el-button class="registerbtn" :class="{ disable: !isFormReady() }" @click="submitForm('registerForm')">同意协议并提交</el-button>
        <!-- <div class="tip">申请后商务经理将在1-2个工作日内与您确认需求</div> -->
      </el-card>

      <!-- 注册成功弹窗 -->
      <el-dialog title="" center width="500px" :visible.sync="resuccessVisible" class="rsvcontent">
        <div class="img">
          <img src="@static/images/wait.png" alt="" />
        </div>
        <div class="word">
          <p class="ti">企业资质审核中</p>
          <p class="desc">您已提交注册信息，请耐心等待</p>
          <p class="desc">一般我们将在<span>1-5个工作日</span>内审核完毕</p>
          <p class="info-text">如有疑问请联系客服 <span>027-96755</span></p>
        </div>
      </el-dialog>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
/**
 * 机构注册页面
 * 功能：机构渠道注册，包含邀请码校验、登录信息、企业信息、发票信息、银行信息等表单
 * 接口：
 *   - GET /master/user/checkInvitationCode 校验邀请码
 *   - POST /master/user/register 机构注册
 *   - POST /master/user/sendCode 发送验证码
 *   - POST /resmgr/upload 文件上传
 */
import footer from '@/components/footer';
import webLogo from '@/components/webLogo';
import city from '../api/city.js';

export default {
  data: () => ({
    /** 是否同意用户协议 */
    isConfirm: false,
    /** 密码是否可见 */
    showPass: false,
    /** 确认密码是否可见 */
    showConfirmPass: false,
    /** 注册成功弹窗是否可见 */
    resuccessVisible: false,
    /** 省份列表 */
    provinces: city.provinces,
    /** 城市列表 */
    citys: [],
    /** 账号是否被手动修改过 */
    accountManuallyChanged: false,
    /** 上一次手机号值，用于判断账号是否需要同步 */
    prevMobile: '',
    /** 是否显示驳回信息 */
    showReject: false,
    /** 驳回原因 */
    rejectReason: '',
    /** 验证码相关 */
    zqcode: '',
    /** 验证码按钮文字 */
    getcodetext: '获取验证码',
    /** 验证码倒计时定时器 */
    timer: null,
    /** 是否可以获取验证码 */
    getcodeflage: true,
    /** 注册表单数据 */
    form: {
      invitationCode: '',
      toucherName: '',
      toucherMobile: '',
      phoneCode: '',
      account: '',
      password: '',
      confirmPassword: '',
      name: '',
      mechanType: '',
      licenseType: '',
      isLicensed: '',
      province: '',
      city: '',
      address: '',
      businessLicenseNo: '',
      businessLicenseImg: '',
      intermediaryLicenseImg: '',
      mechanTaxLevel: '',
      bankUserName: '',
      bankAccount: '',
      bankType: '',
      bankAddress: ''
    },
    /** 表单校验规则 */
    rules: {
      invitationCode: [
        { required: true, message: '请输入邀请码', trigger: 'blur' },
        { pattern: /^[0-9a-zA-Z]{8}$/, message: '邀请码格式错误', trigger: 'blur' }
      ],
      toucherName: [
        { required: true, message: '请输入联系人姓名', trigger: 'blur' },
        { min: 2, max: 20, message: '联系人姓名为2-20个字符', trigger: 'blur' }
      ],
      toucherMobile: [
        { required: true, message: '请输入联系人手机号', trigger: 'blur' },
        { pattern: /^1[0-9]\d{9}$/, message: '请输入正确的11位手机号', trigger: 'blur' }
      ],
      phoneCode: [
        { required: true, message: '请输入短信验证码', trigger: 'blur' },
        { pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur' }
      ],
      account: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { validator: null, trigger: 'blur' }
      ],
      confirmPassword: [
        { required: true, message: '请再次输入密码', trigger: 'blur' },
        { validator: null, trigger: 'blur' }
      ],
      name: [
        { required: true, message: '请输入企业名称', trigger: 'blur' },
        { min: 2, max: 100, message: '企业名称为2-100个字符', trigger: 'blur' }
      ],
      mechanType: [{ required: true, message: '请选择所属行业', trigger: 'change' }],
      licenseType: [{ required: true, message: '请选择持牌类型', trigger: 'change' }],
      province: [{ required: true, message: '请选择省份', trigger: 'change' }],
      city: [{ required: true, message: '请选择城市', trigger: 'change' }],
      address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
      businessLicenseNo: [
        { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
        { pattern: /^[0-9A-Z]{18}$/, message: '请输入18位统一社会信用代码', trigger: 'blur' }
      ],
      businessLicenseImg: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
      intermediaryLicenseImg: [{ required: true, message: '请上传保险中介许可证', trigger: 'change' }],
      mechanTaxLevel: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
      bankUserName: [{ required: true, message: '请输入账户名', trigger: 'blur' }],
      bankAccount: [
        { required: true, message: '请输入对公账号', trigger: 'blur' },
        { pattern: /^\d{8,30}$/, message: '请输入正确的银行账号格式', trigger: 'blur' }
      ],
      bankType: [{ required: true, message: '请输入开户行', trigger: 'blur' }],
      bankAddress: [{ required: true, message: '请输入开户支行', trigger: 'blur' }]
    }
  }),
  components: {
    webLogo,
    'app-footer': footer
  },
  created() {
    // 初始化密码自定义校验器
    this.rules.password[1].validator = this.validatePassword;
    this.rules.confirmPassword[1].validator = this.validateConfirmPassword;
  },
  methods: {
    /**
     * 密码强度校验
     * @param rule - 校验规则对象
     * @param value - 当前输入值
     * @param callback - 校验结果回调
     */
    validatePassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('密码长度为8-16位'));
      } else {
        var types = 0;
        if (/[a-z]/.test(value)) types++;
        if (/[A-Z]/.test(value)) types++;
        if (/[0-9]/.test(value)) types++;
        if (/[^a-zA-Z0-9]/.test(value)) types++;
        if (types < 3) {
          callback(new Error('密码需包含大小写字母、数字和特殊字符中至少三种'));
        } else {
          callback();
        }
      }
    },
    /**
     * 确认密码一致性校验
     * @param rule - 校验规则对象
     * @param value - 当前输入值
     * @param callback - 校验结果回调
     */
    validateConfirmPassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },
    /**
     * 校验邀请码是否有效，有效时回显数据到表单
     */
    checkInvitationCode() {
      var code = this.form.invitationCode;
      if (!code || !/^[0-9a-zA-Z]{8}$/.test(code)) return;
      this.$http({
        url: '/master/user/checkInvitationCode',
        type: 'get',
        params: {
          invitationCode: code
        }
      }).then(data => {
        if (data.httpCode == 200 && data.data) {
          var res = data.data;
          // 驳回状态处理
          if (res.status == -1) {
            this.showReject = true;
            this.rejectReason = res.reason || '';
          } else {
            this.showReject = false;
            this.rejectReason = '';
          }
          this.form.toucherName = res.toucherName || '';
          this.form.toucherMobile = res.toucherMobile || '';
          this.form.account = res.account || res.toucherMobile || '';
          this.form.name = res.name || '';
          this.form.mechanType = res.mechanType || '';
          this.form.licenseType = res.licenseType || '';
          this.form.isLicensed = res.isLicensed || '';
          this.form.province = res.province || '';
          this.form.city = res.city || '';
          this.form.address = res.address || '';
          this.form.businessLicenseNo = res.businessLicenseNo || '';
          this.form.businessLicenseImg = res.businessLicenseImg || '';
          this.form.intermediaryLicenseImg = res.intermediaryLicenseImg || '';
          this.form.bankUserName = res.bankUserName || '';
          this.form.bankAccount = res.bankAccount || '';
          this.form.bankType = res.bankType || '';
          this.form.bankAddress = res.bankAddress || '';
          // mechanTaxLevel直接赋值，3=普票，1/2/4=专票不同税率
          if (res.mechanTaxLevel) {
            this.form.mechanTaxLevel = res.mechanTaxLevel;
          }
          if (res.province) {
            this.provinceChange();
            this.form.city = res.city || '';
          }
          this.prevMobile = res.toucherMobile || '';
          this.accountManuallyChanged = false;
        }
      });
    },
    /**
     * 手机号失焦处理，账号为空时默认填充手机号
     */
    onMobileBlur() {
      if (!this.form.account && this.form.toucherMobile) {
        this.form.account = this.form.toucherMobile;
        this.accountManuallyChanged = false;
      }
      this.prevMobile = this.form.toucherMobile;
    },
    /**
     * 根据银行账号查询所属银行名称
     * @param num - 银行账号
     */
    getBankInfo(num) {
      if (!num) {
        return
      }
      this.$http({
        url: '/insure/getBankInfo?cardNumber=' + num,
        type: 'post',
      })
        .then((data) => {
          if (data.data.bankName) {
            this.form.bankType = data.data.bankName
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    /**
     * 校验登录账号是否已存在
     */
    checkAccountExist() {
      var account = this.form.account;
      if (!account) return;
      // 标记账号已被手动修改
      if (account !== this.form.toucherMobile) {
        this.accountManuallyChanged = true;
      }
      // TODO: 待接入账号存在性校验接口，目前仅做前端提示
      // this.$http({
      //   url: "/master/user/checkAccount",
      //   type: "get",
      //   params: { account: account },
      // }).then(function (data) {
      //   if (data.httpCode === 200 && data.data && data.data.exists) {
      //     that.$message.error("登录账号已存在，请修改登录账号信息");
      //   }
      // });
    },
    /**
     * 获取短信验证码，60秒倒计时
     */
    getcode() {
      var reg = /^1[0-9]\d{9}$/;
      if (this.form.toucherMobile) {
        if (reg.test(this.form.toucherMobile)) {
          if (this.getcodeflage) {
            this.getcodeflage = false;
            this.sendCode(this.form.toucherMobile);
            this.getcodetext = 60;
            this.timer = setInterval(() => {
              this.getcodetext--;
              if (this.getcodetext == 0) {
                this.getcodeflage = true;
                clearInterval(this.timer);
                this.getcodetext = '获取验证码';
              }
            }, 1000);
          }
        } else {
          this.$message.error('请输入正确的手机号');
        }
      } else {
        this.$message.error('请输入手机号');
      }
    },
    /**
     * 发送短信验证码请求
     * @param phone - 手机号
     */
    async sendCode(phone) {
      var signNumber = await this.$tools.phoneSignature();
      this.$http({
        url: '/master/user/sendCode',
        type: 'post',
        params: {
          mobile: phone,
          source: 'login_register',
          signature: signNumber
        }
      }).then(data => {
        this.zqcode = data.data;
      });
    },
    /**
     * 省份变更处理，联动加载城市列表
     */
    provinceChange() {
      this.citys = [];
      this.form.city = '';
      for (var item of this.provinces) {
        if (item.name === this.form.province) {
          this.citys = item.cities;
        }
      }
    },
    /**
     * 文件上传前校验，限制文件类型和大小
     * @param file - 上传的文件对象
     * @returns {boolean} 是否允许上传
     */
    beforeUpload(file) {
      var allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      var isAllowedType = allowedTypes.indexOf(file.type) >= 0;
      var isLt10M = file.size / 1024 / 1024 <= 10;
      if (!isAllowedType) {
        this.$message.error('仅支持JPG/PNG/JPEG格式文件');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB');
        return false;
      }
      return true;
    },
    /**
     * 文件上传成功回调，将返回的URL赋值到对应表单字段
     * @param res - 上传接口返回数据
     * @param field - 表单字段名
     */
    uploadSuccess(res, field) {
      if (res.data && res.data[0] && res.data[0].wwwurl) {
        this.form[field] = res.data[0].wwwurl;
        // 触发表单校验以清除错误提示
        this.$refs.registerForm.validateField(field);
      }
    },
    /**
     * 判断URL是否为图片格式
     * @param url - 文件URL
     * @returns {boolean} 是否为图片
     */
    isImageUrl(url) {
      if (!url) return false;
      var ext = url
        .split('.')
        .pop()
        .toLowerCase()
        .split('?')[0];
      return ['jpg', 'jpeg', 'png', 'gif', 'bmp'].indexOf(ext) >= 0;
    },
    /**
     * 从URL中提取文件名
     * @param url - 文件URL
     * @returns {string} 文件名
     */
    getFileName(url) {
      if (!url) return '';
      var parts = url.split('/');
      var fullName = parts[parts.length - 1] || '已上传文件';
      // 去除URL查询参数
      return fullName.split('?')[0];
    },
    /**
     * 判断表单是否填写完整（控制提交按钮可用状态）
     * @returns {boolean} 表单是否填写完整
     */
    isFormReady() {
      var f = this.form;
      // 基础必填字段
      var baseFields = [
        f.invitationCode,
        f.toucherName,
        f.toucherMobile,
        f.phoneCode,
        f.account,
        f.password,
        f.confirmPassword,
        f.name,
        f.mechanType,
        f.province,
        f.city,
        f.address,
        f.businessLicenseNo,
        f.businessLicenseImg,
        f.mechanTaxLevel,
        f.bankUserName,
        f.bankAccount,
        f.bankType,
        f.bankAddress
      ];
      // 如果是持牌，添加持牌类型校验
      if (f.isLicensed == 1) {
        baseFields.push(f.licenseType);
      }
      // 如果是保险中介，添加保险中介许可证校验
      if (f.mechanType == 3) {
        baseFields.push(f.intermediaryLicenseImg);
      }
      for (var i = 0; i < baseFields.length; i++) {
        if (!baseFields[i] && baseFields[i] !== 0) {
          return false
        };
      }
      return true;
    },
    /**
     * 提交注册表单
     * @param formName - 表单ref名称
     */
    submitForm(formName) {
      if (!this.isConfirm) {
        this.$message.error('请同意服务条款');
        return;
      }
      this.$refs[formName].validate((valid, err) => {
        if (valid) {
          this.register();
        } else {
          if (err) {
            var errKeys = Object.keys(err);
            if (errKeys.length > 1) {
              this.$message.error('请输入正确的信息');
            } else {
              var firstKey = errKeys[0];
              var firstErr = err[firstKey][0];
              this.$message.error(firstErr.message || '请输入正确的信息');
            }
          }
        }
      });
    },
    /**
     * 调用注册接口提交数据
     */
    register() {
      var f = this.form;
      var params = {
        phoneCode: f.phoneCode,
        invitationCode: f.invitationCode,
        toucherName: f.toucherName,
        toucherMobile: f.toucherMobile,
        account: f.account,
        password: f.password,
        mechanType: f.mechanType,
        licenseType: f.licenseType,
        isLicensed: f.isLicensed,
        name: f.name,
        province: f.province,
        city: f.city,
        address: f.address,
        businessLicenseNo: f.businessLicenseNo,
        businessLicenseImg: f.businessLicenseImg,
        intermediaryLicenseImg: f.intermediaryLicenseImg,
        mechanTaxLevel: f.mechanTaxLevel,
        bankType: f.bankType,
        bankAccount: f.bankAccount,
        bankUserName: f.bankUserName,
        bankAddress: f.bankAddress
      };
      this.$http({
        url: '/master/user/register',
        type: 'post',
        params: params
      }).then(data => {
        if (data.httpCode == 200) {
          this.getcodeflage = true;
          clearInterval(this.timer);
          this.getcodetext = '获取验证码';
          this.$refs.registerForm.resetFields();
          this.isConfirm = false;
          this.showReject = false;
          this.resuccessVisible = true;
        } else {
          this.$message.error(data.msg || '注册失败，请稍后重试');
        }
      });
    },
    /**
     * 跳转到首页
     */
    goIndex() {
      location.href = '/home/index.html';
    },
    /**
     * 跳转到登录页
     */
    gologin() {
      this.$router.push('/login');
    },
    /**
     * 在新窗口打开链接
     * @param url - 目标链接地址
     */
    link(url) {
      window.open(url);
    }
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>
<style lang="scss">
@import '~@/sass/pages/register';
</style>
